
import React from 'react';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { AccessTime } from '@material-ui/icons';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

export const MyTimePicker = ({ id, label, value, error, required, onChange, ...rest }) => {
  // seeting the by default time if id is duration
  const generateTimes = () => {
    const times = [];
    for (let hour = 0; hour < 24; hour++) {
      const hourString = hour < 10 ? `0${hour}` : `${hour}`;
      times.push(`${hourString}:00`);
      times.push(`${hourString}:30`);
    }
    return times;
  };

  const times = generateTimes();
  const handleTimeChange = (event) => {
    const [hours, minutes] = event.target.value.split(':');
    const updatedDate = new Date(value);
    updatedDate.setHours(hours);
    updatedDate.setMinutes(minutes);
    
    //setSelectedTime(event.target.value); // Store selected time for display
    onChange(updatedDate); // Update the date with the selected time
  };
  const formatDateToHouseAndTime=(date)=>{
    const updatedDate = new Date(value);
    var hour=updatedDate.getHours()
    const hourString = hour < 10 ? `0${hour}` : `${hour}`;
    var minutes=updatedDate.getMinutes()
    const minuteString = minutes < 10 ? `0${minutes}` : `${minutes}`;

    return `${hourString}:${minuteString}`
  }

  return (
    <FormControl fullWidth variant='outlined' size='small'>
       <InputLabel id="time-select-label">{label}</InputLabel>
<Select
labelId="time-select-label"
    fullWidth
    variant='outlined'
    value={formatDateToHouseAndTime(value)}
    onChange={handleTimeChange}
    label={label}
    
  >
    {times.map((time, index) => (
      <MenuItem key={index} value={time}>
        {time}
      </MenuItem>
    ))}
  </Select>
    </FormControl>
    
    // <MuiPickersUtilsProvider utils={DateFnsUtils}>
    //   <KeyboardTimePicker
    //     ampm={false}
    //     fullWidth
    //     showToolbar
    //     inputVariant="outlined"
    //     size="small"
    //     label={label}
    //     value={value}
    //     onChange={onChange}
    //     KeyboardButtonProps={{
    //       "aria-label": label,
    //     }}
    //     InputLabelProps={{
    //       shrink: true,
    //     }}
    //     required={required}
    //     error={error}
    //     {...rest}
    //     keyboardIcon={<AccessTime />}
    //     autoOk
    //   />
    // </MuiPickersUtilsProvider>
  );
};
